import React from 'react'
import { StyledFullDetailsSection } from './dashboard-user-details-main-section.style'
import DashboardUserDetailsMainSectionItem from './dashboard-user-details-main-section-item'
import { userDetailsItemData } from '../../services/userDetailsItemData'

const DashboardUserDetailsMainSection = () => {
    return (
        <StyledFullDetailsSection>
            {userDetailsItemData.map((item, idx) => (
                <DashboardUserDetailsMainSectionItem key={idx} item={item} />
            ))}
        </StyledFullDetailsSection>
    )
}

export { DashboardUserDetailsMainSection }